/**
 * Was die Szene zeigt: ein Fahrzeug, ein Seezeichen, eine Ausweichsituation, oder nichts.
 *
 * Eigene Datei und nicht in `Viewer.tsx`, weil die Zuordnung ohne Three.js prüfbar sein
 * muss: der Test schickt jede Karte des Bestands hindurch.
 */
export type Subject =
  | { kind: 'vessel'; id: string }
  | { kind: 'buoy'; id: string }
  | { kind: 'scenario'; id: string }
  /** Schallsignale haben kein Bild: die Szene bleibt dann weg. */
  | { kind: 'signal'; id: string }

/**
 * Was die Szene zu einer Karte zeigt, an genau einer Stelle.
 *
 * Diese Zuordnung stand dreimal im Code, in Quiz, Karteikarten und Prüfungsbogen, und
 * jede Kopie fiel für unbekannte Karten auf "Fahrzeug" zurück. Als mit Goal 20 die
 * Schallzeichen der Binnenschifffahrt dazukamen, wurden zwei Kopien angepasst und die
 * dritte übersehen: der Prüfungsbogen suchte ein Schiff mit der Kennung eines Tons, die
 * Szene scheiterte, und der Bildschirm baute sich ohne Ende neu auf. Eine Stelle kann
 * nicht auseinanderlaufen, und für eine unbekannte Kartenart wirft sie, statt zu raten.
 */
export function subjectOfCard(cardId: string): Subject {
  const trenner = cardId.indexOf(':')
  const kind = cardId.slice(0, trenner)
  const id = cardId.slice(trenner + 1)
  switch (kind) {
    case 'state':
    case 'binnen':
      return { kind: 'vessel', id }
    case 'buoy':
      return { kind: 'buoy', id }
    // Ein Schallzeichen hat kein Bild, das der See nicht und das der Binnenschifffahrt
    // nicht: die App zeigt dann keine Szene.
    case 'signal':
    case 'binnenSignal':
      return { kind: 'signal', id }
    default:
      throw new Error(`Karte ${cardId}: keine bekannte Kartenart`)
  }
}
